"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var create_exports = {};
__export(create_exports, {
  attributionHtml: () => attributionHtml,
  osAttribution: () => osAttribution,
  standardAttribution: () => standardAttribution
});
module.exports = __toCommonJS(create_exports);
function thisYear() {
  return `${(/* @__PURE__ */ new Date()).getFullYear()}`;
}
function escapeText(string) {
  return string.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function years(from, to) {
  if (from == null) {
    if (to == null) {
      return "";
    } else {
      return escapeText(to);
    }
  } else {
    if (to == null) {
      return `${escapeText(from)}-${thisYear()}`;
    } else {
      return `${escapeText(from)}-${escapeText(to)}`;
    }
  }
}
function link(url, label) {
  return url == null ? label : `<a href="${url}" target="_blank">${label}</a>`;
}
function attributionHtml(attr) {
  switch (attr.type) {
    case "StandardAttribution": {
      const { what, who, url, from, to } = attr;
      return link(url, `${escapeText(what)} Copyright ${years(from, to)} ${escapeText(who)}`);
    }
    case "OsAttribution": {
      const { what, url, from, to } = attr;
      return link(url, `${escapeText(what)} Crown Copyright ${years(from, to)}`);
    }
  }
}
function standardAttribution(options) {
  return { type: "StandardAttribution", ...options };
}
function osAttribution(options) {
  return { type: "OsAttribution", ...options };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  attributionHtml,
  osAttribution,
  standardAttribution
});
//# sourceMappingURL=create.js.map
